/* Mayekoo Project Record share control — dependency-free and safe under theme-editor reloads. */
(function () {
  'use strict';

  function setStatus(button, message) {
    var wrapper = button.closest('.mk-actions');
    var status = wrapper ? wrapper.querySelector('[data-mk-share-status]') : null;
    if (status) status.textContent = message;
  }

  function bind(button) {
    if (button.dataset.mkShareBound === 'true') return;
    button.dataset.mkShareBound = 'true';
    button.addEventListener('click', async function () {
      var data = { title: document.title, url: window.location.href };
      try {
        if (navigator.share) {
          await navigator.share(data);
          setStatus(button, 'Share options opened.');
          return;
        }
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(data.url);
          setStatus(button, 'Link copied.');
          return;
        }
        window.prompt('Copy this project link:', data.url);
        setStatus(button, 'Project link ready to copy.');
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        setStatus(button, 'The link could not be shared. Copy it from your browser address bar.');
      }
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-mk-share]').forEach(bind);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
